module.exports = __webpack_public_path__ + "static/media/warnning-icon.9b59c386.svg";